import { DotProps } from 'react-multi-carousel'
import { DotButton } from './SlideshowDot.styled'

const SlideshowDot: React.FC<DotProps> = ({ onClick, active }) => {
  return <DotButton isActive={active} onClick={onClick} />
}

export default SlideshowDot
